export const reactSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#f8f9fa",
    borderColor: state.isFocused ? "#ff9f43" : "#dee2e6",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(255,159,67,.25)" : "none",
    "&:hover": { borderColor: "#ff9f43" },
    minHeight: "38px",
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#ff9f43"
      : state.isFocused
        ? "#fff3e6"
        : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#67748e",
    fontWeight: state.isSelected ? 500 : 400,
    cursor: "pointer",
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#ff9f43",
    borderRadius: "6px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#ffffff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#ffffff",
    ":hover": {
      backgroundColor: "#e8892d",
      color: "#ffffff",
    },
  }),

  placeholder: (base) => ({
    ...base,
    color: "#67748e",
  }),

  singleValue: (base) => ({
    ...base,
    color: "#67748e",
  }),

  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
